import { render, staticRenderFns } from "./CandidateRowRDED.vue?vue&type=template&id=ecc79fca&scoped=true&lang=pug"
import script from "./CandidateRowRDED.vue?vue&type=script&lang=js"
export * from "./CandidateRowRDED.vue?vue&type=script&lang=js"
import style0 from "./CandidateRowRDED.vue?vue&type=style&index=0&id=ecc79fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc79fca",
  null
  
)

export default component.exports